/**
 * O `etsStatus` do equipamento chega em DOIS formatos (SGD-3616):
 *  - como NOME, ex.: "Sincronizando - 2D5DE7", quando herdado da usina
 *    (ver FindAllSynopticStatusByEquipmentUseCase no backend: usina sincronizando propaga o nome);
 *  - como os BITS crus do ETS, ex.: "110000", caso contrário
 *    (ver EtsStatus no backend: índice 1 = respondendo/não-respondendo; índice 3 = habilitado/inibido).
 *
 * Este helper normaliza os dois formatos em flags semânticas, pra os cards não dependerem do formato.
 */
const ETS_BITS_PATTERN = /^[01]{5,6}$/;

const SYNCHRONIZING_NAME = 'Sincronizando';
const NO_COMMUNICATION_NAME = 'Não responde';
const INHIBITED_NAME = 'Inibído';

// O nome pode vir puro ("Inibído") ou com a cor anexada ("Inibído - 6e6767").
const parseStatusName = (status?: string): string => (status ?? '').split(' - ')[0].trim();

export interface EquipmentStatusFlags {
    synchronizing: boolean;
    inhibited: boolean;
    withoutCommunication: boolean;
}

export const resolveEquipmentStatusFlags = (status?: string): EquipmentStatusFlags => {
    const raw = (status ?? '').trim();

    if (ETS_BITS_PATTERN.test(raw)) {
        return {
            // "Sincronizando" só chega como nome (herdado da usina), nunca pelos bits do equipamento.
            synchronizing: false,
            inhibited: raw.charAt(3) === '0',
            withoutCommunication: raw.charAt(1) === '0',
        };
    }

    const name = parseStatusName(raw);
    return {
        synchronizing: name === SYNCHRONIZING_NAME,
        inhibited: name === INHIBITED_NAME,
        withoutCommunication: name === NO_COMMUNICATION_NAME,
    };
};
